import { ConnectIncomingCall, ConnectIncomingQueueCall, DismissCall, DismissQueueCall, InitiateCall } from 'app/store/call/call.actions';
import { UpdateReminder } from 'app/store/reminder/reminder.actions';
import { Notification } from './notification.model';

export const viewBusiness = {
  text: 'View',
  function: ({ borrowerId, meta }: Notification, { router, store }) => {
    if (borrowerId && borrowerId !== -1) {
      router.navigate(['/borrower/', borrowerId]);
    }
    if (meta?.reminderId) {
      store.dispatch(new UpdateReminder(meta.reminderId, { expired: 1, occurred: 1 }));
    }
  },
};

export const viewMessagesTab = {
  text: 'Message',
  function: ({ borrowerId, meta }: Notification, { store, router }) => {
    if (borrowerId && borrowerId !== -1) {
      router.navigateByUrl(`/borrower/${borrowerId}?pane=messages`);
    }
    if (meta?.reminderId) {
      store.dispatch(new UpdateReminder(meta.reminderId, { expired: 1, occurred: 1 }));
    }
  }
};

export const viewDocumentsTab = {
  text: 'View Docs',
  function: ({ borrowerId }: Notification, { router }) => {
    if (borrowerId && borrowerId !== -1) {
      router.navigateByUrl(`/borrower/${borrowerId}?pane=documents`);
    }
  }
};

export const call = {
  text: 'Call',
  function: ({ borrowerId, meta }: Notification, { store, router }) => {
    if (meta?.phone && borrowerId) {
      router.navigate(['/borrower/', borrowerId]);
      store.dispatch(new InitiateCall({ borrowerId, phone: meta.phone }));
    }
    if (meta?.reminderId) {
      store.dispatch(new UpdateReminder(meta.reminderId, { expired: 1, occurred: 1 }));
    }
  }
};

export const snoozeFiveMin = {
  text: 'Snooze 5 Min',
  function: ({ meta }: Notification, { store }) => {
    if (meta?.reminderId) {
      store.dispatch(new UpdateReminder(meta.reminderId, {
        expires: new Date().setMinutes(new Date().getMinutes() + 5),
        expired: 0,
        occurred: 0
      }));
    }
  }
};

export const snoozeOneHour = {
  text: 'Snooze 1 Hr',
  function: ({ meta }: Notification, { store }) => {
    if (meta?.reminderId) {
      store.dispatch(new UpdateReminder(meta.reminderId, {
        expires: new Date().setHours(new Date().getHours() + 1),
        expired: 0,
        occurred: 0
      }));
    }
  }
};

export const markAsCompleted = {
  text: 'Mark Complete',
  function: ({ meta }: Notification, { store }) => {
    if (meta?.reminderId) {
      store.dispatch(new UpdateReminder(meta.reminderId, { expired: 1, occurred: 1 }));
    }
  }
};

export const dismissCall = {
  text: 'Dismiss',
  function: ({ meta }: Notification, { store }) => {
    if (meta?.callId) {
      if (meta.callQueue) {
        store.dispatch(new DismissQueueCall(meta.callId, { disposition: 'Inbound call dismissed.' }));
      } else if (meta.connectSoftPhone) {
        store.dispatch(new DismissCall(meta.callId, { disposition: 'Inbound call dismissed.' }));
      }
    }
  },
};

export const startCall = {
  text: 'Start Call',
  function: ({ borrowerId, meta }: Notification, { store, router }) => {
    if (meta?.callId) {
      if (borrowerId && borrowerId !== -1) {
        router.navigate(['/borrower/', borrowerId]);
      }
      if (meta.callQueue) {
        return store.dispatch(new ConnectIncomingQueueCall(meta.callId));
      }
      if (meta.connectSoftPhone) {
        return store.dispatch(new ConnectIncomingCall(meta.callId, meta.connectSoftPhone));
      }
    }
  },
};
